/**
 * user模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http';
//import qs from 'qs'; // post请求不再需要导入qs，因为再http中使用qs统一处理post请求的序列化问题
const user = {
  // 供应商登录、Ciy登录
  login(params) {
    return axios.post(`${Vue.prototype.$base.API_PATH}/user/login`, params);
  },
  // 供应商\Ciy退出登录
  logout() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/user/logout`);
  },
  //等到当前登录用户信息
  me() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/user`);
  },
  //等到当前登录菜单
  menus() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/user/menus`);
  },
  //向指定邮件发送验证码
  send(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH_OPEN}/user/validate`, {
      params: params
    });
  },
  //验证码校验
  verificationCode(params) {
    return axios.post(`${Vue.prototype.$base.API_PATH_OPEN}/user/validate`, params);
  },
  //变更邮箱地址与状态
  emailChange(params) {
    return axios.post(`${Vue.prototype.$base.API_PATH_OPEN}/user/email-change`, params);
  },
  //供应商注册
  signIn(params) {
    return axios.put(`${Vue.prototype.$base.API_PATH_OPEN}/user/sign-in`,params);
  },
  //变更邮箱地址与状态
  forgotPassword(params) {
    return axios.post(`${Vue.prototype.$base.API_PATH_OPEN}/user/forgot_password`, params);
  },
  // 防颤抖提交key
  repeatToken() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/user/repeat/token`);
  },

}

export default user;



// WEBPACK FOOTER //
// ./src/api/user.js